import moment from "moment";
import { useState } from "react";
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { showMessage } from "../../../config.js";
import WorkflowMasterSummary from '../../../components/logged_in/WorkflowMasterSummary';

export default function Workflows({ company, setTab, setIsWorkflowReport, setCompanyDashboardTab, permissionLevel }) {

	const user = useSelector(state => state.user);

	const [showPriorityTooltip, setShowPriorityTooltip] = useState(false);
	const [showPriorityList, setShowPriorityList] = useState(() => !!localStorage.getItem('priorityManager'));

	const redirectWorkflowTab = async (moduleName) => {
		if ((user['role'] == "Advisor" || user['role'] == "Investor") && (permissionLevel == 'DASHBOARD')) {
			showMessage('You have Dashboard access only!');
			return;
		}
		await setTab(`${moduleName}-report`);
		setCompanyDashboardTab('Dashboard');
		await setIsWorkflowReport(true);
		localStorage.setItem('isWorkflowOpen', true)
	};

	const handleChecklistMessages = (isActive, isRedirect) => {
		if ((user['role'] == "Advisor" || user['role'] == "Investor") && permissionLevel == 'DASHBOARD') {
			showMessage(`You have ${permissionLevel} access only!`);
			return;
		};
		if (!isActive) return showMessage(`Module not activated yet!`);
		if (!isRedirect) return showMessage(`Module not started yet!`);
	};

	const checklistModules = (modules) => {
		return <>{modules.length > 0
			? Object.values(modules).map(module => {
				let isRedirect = false;
				if (module?.['stats'].completionPercent > 0) isRedirect = true;

				return <div className={`bo7 w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem mx1rem my1-5rem pr bsbb ${!module['isActive'] && ' op0-5'} ${module?.['createdBy']?.['role'] == 'Advisor' && ' advisor-bg'} ${module?.['createdBy']?.['role'] == 'Investor' && ' investor-bg'}`}>
					<Link className="ttc fs1rem fw500 c15 lh2 zi1 w100">
						<Link to={(module['isActive'] && isRedirect && permissionLevel != 'DASHBOARD') && `#${module['type']}-report`} onClick={() => { (module['isActive'] && isRedirect) ? redirectWorkflowTab(module['type']) : handleChecklistMessages(module['isActive'], isRedirect) }} className="cp w100 h100" style={{ minHeight: '130px' }}>
							<div className='w100 df aic'>
								<i className='icon-diligenstia mr1rem'>
									<img className="br5px w50px" src={module?.['imageURL'] || require(`../../../../images/checklist-logo.png`)} alt="" />
								</i>
								<button className='cp fs1rem fw500 bg1 c4-hover c15 lh2 title-box-feature tal' style={{ background: 'transparent' }}>{module['type']}</button>
							</div>
							<div className="w100 df jcsb">
								<div className="df fdc ">
									<p className="c12 fw300 fs0-75rem mt3rem">{(module?.['createdAt'] || module?.['sections']?.[0]?.['createdAt']) ? moment(module?.['createdAt'] || module?.['sections']?.[0]?.['createdAt']).format('L') : '-'}</p>
									<button className={`df bg1 br50px bw1px bss fs0-75rem px1rem py0-5rem mt0-5rem bsbb aic ${module['isActive'] ? ' bo3 c3' : ' bo12 c12'}`}>{module['isActive'] ? 'Activated' : 'Deactivated'}</button>
								</div>
								<div className="df fdc jcc aic">
									<div className={`progress-bar workflow-report-progress ${module?.stats?.workflowCompletionPercent > 75 ? 'workflow-progress-green' : module?.stats?.workflowCompletionPercent > 26 ? 'workflow-progress-yellow' : module?.stats?.workflowCompletionPercent > 1 ? ' workflow-progress-pink' : '  workflow-progress-grey'}`}
										style={{ width: 50, height: 50, borderRadius: '50%', margin: 0, border: '2px solid #F1F1F1' }}>
										<CircularProgressbar
											text={module?.stats?.workflowCompletionPercent ? (module?.stats?.workflowCompletionPercent) + "%" : 'N/A'}
											styles={buildStyles({
												strokeWidth: '0',
												textSize: '20px',
												trailColor: '#FBFBFB',
												stroke: 'transparent',
												strokeLinecap: 'butt',
												backgroundColor: '#FBFBFB',
												pathTransitionDuration: 0.5,
												dominantBaseline: 'ideographic',
											})}
										/>
									</div>
									<span style={{ marginBottom: "0", }} className="tac c15 fs0-75rem fw300">Workflow <br /> Completeness</span>
								</div>
							</div>
						</Link>
					</Link>
				</div>
			})
			: <p className="w100 tac fs1-75rem fw500 c14 fsi">No Workflow Added!</p>
		}</>
	};

	if (showPriorityList) return <WorkflowMasterSummary company={company} setTab={setTab} />;

	return (
		<>
			<div className='sectionWrapper py1rem fs0-75rem pr anylist-builder-tab'>
				<div className='mt1rem bss px1rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb3rem pr bsbb *'>
					<div className="df aic jcfs w100 pl1rem mb0-5rem">
						<h3 className="fs1-25rem c15 mr1rem">Workflows</h3>
						<div className="df aic mr1rem pr">
							<button
								className="df aic br50px py0-5rem px1-5rem bss bw1px bo4 c15 fs0-875rem fw500 cp mr0-75rem fsi"
								style={{ backgroundColor: '#F0F2FD', border: '1px solid #DBDFEE' }}
								onClick={() => setShowPriorityList(true)}
							>
								Priority
								<img src={require('../../../../images/featureWorkflow/warning icon.svg')} alt="Priority" className="20px 20px ml0-5rem" />
							</button>
							<div
								className="pa"
								style={{ right: "10px", top: 0 }}
								onMouseEnter={() => setShowPriorityTooltip(true)}
								onMouseLeave={() => setShowPriorityTooltip(false)}
							>
								<img src={require('../../../../images/featureWorkflow/info-icon-tab.svg')} alt="info" className="20px 20px cp" />
								{showPriorityTooltip && (
									<div className="pa br10px p1rem fs0-75rem fw400 c15 shadow" style={{ width: '320px', right: 0, top: '-110px', backgroundColor: '#F5F0BC', zIndex: 100 }}>
										The PriorityList report consolidates the most critical remediation issues across all diligence modules. It provides a structured roadmap for achieving investment readiness.
									</div>
								)}
							</div>
						</div>
					</div>
					{/* Checklist Modules */}
					{(company?.['modules'] && Object.values(company['modules']).length > 0) &&
						checklistModules(Object.values(company['modules']).filter(item => (((item?.['category'] == "all" || item?.['category'] == "internal" || item?.['category'] == "external" || item?.['category'] == "partner") && item['stats']['completionPercent'] > 0) || (item['isHealthBoost'] && item['stats']['completionPercent'] > 0))))
					}
				</div>
			</div>
		</>
	)
}
